import { format, isValid, parseISO } from 'date-fns';

export const formatIsoDate = (
  iso: string,
  displayFmt = 'dd MMM yyyy, hh:mm a',
) => {
  const date = parseISO(iso.trim());
  return isValid(date) ? format(date, displayFmt) : iso;
};
